module.exports = { prefix: 'fas', iconName: 'caret-down', icon: [320, 512, [], "f0d7", "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"] };


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/seiu503-wordpress/wp-content/themes/seiu503-wp/node_modules/@fortawesome/fontawesome-free-solid/faCaretDown.js
// module id = 17
// module chunks = 0